import { render, staticRenderFns } from "./OnboardingCoachSport.vue?vue&type=template&id=0e379b78&"
import script from "./OnboardingCoachSport.vue?vue&type=script&lang=ts&"
export * from "./OnboardingCoachSport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports